<template>
  <ProductsHubModule
    :module-data="document"
    data-luko-tracking="Page-Products"
  />
</template>

<script>
import { formatMetaDatas } from '~/utils/metaData'
import ProductsHubModule from '~/modules/ProductsHub'

export default {
  name: 'Hub',

  head() {
    const { title, subtitle, backgroundImage } = this.document.data.body.find(
      (e) => e.slice_type === 'hero'
    ).primary

    const defaultMeta = {
      twitter_title: title[0]?.text,
      twitter_description: subtitle[0]?.text,
      twitter_image: backgroundImage.url,
    }

    return formatMetaDatas(this.metaDatas, this.$route.path, defaultMeta)
  },

  components: {
    ProductsHubModule,
  },

  async asyncData({ app, $prismic, store, error }) {
    try {
      const document = await $prismic.api.getSingle('products_hub', {
        lang: app.i18n.localeProperties.prismicIso,
      })

      store.dispatch('setAlternateLanguages', document.alternate_languages)
      store.commit('page/UPDATE', {
        theme: '2021Q4-pink',
      })

      document.data.body = document.data.body.map((slice) => {
        if (slice.slice_type !== 'article_anchor') return slice

        slice.items = document.data.body1
        return slice
      })

      return {
        document,
        metaDatas: document.data.body2 || [],
      }
    } catch (e) {
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
